var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"loading-bar",attrs:{"width":"100%","height":_vm.height}},[_c('transition',{attrs:{"name":"bar"}},[_c('rect',{attrs:{"x":"0","y":"0","height":_vm.height,"width":_vm.percentage}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }